import { render, staticRenderFns } from "./PuzzleThanks.vue?vue&type=template&id=36fe29c2&scoped=true&"
import script from "./PuzzleThanks.vue?vue&type=script&lang=js&"
export * from "./PuzzleThanks.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleThanks.vue?vue&type=style&index=0&id=36fe29c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fe29c2",
  null
  
)

export default component.exports